import React, { useEffect, useState } from "react";
import Button from "../../../../components/Buttons/Button";
import useSelectBrand from "../../../../hooks/styles/useSelectBrand";
import usePrivacyAgree from "../../hooks/usePrivacyAgree";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../../../components/Modal/CustomModal";
import { MdError } from "react-icons/md";
import useConnectChatingServer from "../../hooks/agent/useConnectChatingServer";


export const TableRow = ({ category, items, styles }) => {
  return (
    <tr>
      <th className="font-medium align-middle border border-neutral-200">
        {category}
      </th>
      <td className={`p-2 border align-middle border-neutral-200 ${styles}`}>
        <ul>
          {items.map((item, index) => (
            <li
              key={index}
              className="flex gap-1.5 text-neutral-500 align-middle font-medium"
            >
              {item}
            </li>
          ))}
        </ul>
      </td>
    </tr>
  );
};

const PrivacyAgree = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();
  const [checkAll, setCheckAll] = useState({
    age: false,
    ProvideInform: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  const {
    submit,
    loading: agreeLoading,
    isAgree,
    isClicked,
    setIsClicked,
  } = usePrivacyAgree();
  const { hex } = useSelectBrand();
  const [openIndex, setOpenIndex] = useState(null);

  const { status } = useConnectChatingServer({
    isAgree,
    onRequestClose,
    setCheckAll,
    isClicked,
    setIsClicked,
  });

  useEffect(() => {
    if (agreeLoading) {
      setIsLoading(true);
    }
    if (status) {
      setIsLoading(false);
    }
  }, [agreeLoading, status]);
  const handleCheckAll = () => {
    const allChecked =
      checkAll.age && checkAll.ProvideInform;
    setCheckAll({
      age: !allChecked,
      ProvideInform: !allChecked,
    });
  };

  const handleSubmit = () => {
    const allChecked =
      checkAll.age && checkAll.ProvideInform;
    if (allChecked) {
      submit();
    } else {
      alert("개인정보 수집 이용 동의 내역에 모두 동의해 주세요");
    }
  };

  const onClose = () => {
    navigate(-1);
    setCheckAll({
      age: false,
      ProvideInform: false,
    });
  };

  const handleAccordionClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleCheckChange = (type) => {
    setCheckAll((prevCheckAll) => ({
      ...prevCheckAll,
      [type]: !prevCheckAll[type],
    }));
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      btnClose
      contentLabel="디지털 상담 개인정보 제공 동의"
      onClose={onClose}
      modalBottom
    >
      <div className="flex flex-col w-full">
        <h3 className="w-full flex justify-center mb-5 text-2xl font-semibold text-center flex-shrink-0">
          개인정보 관련 사항 안내
        </h3>
        <div className="flex-1 overflow-y-auto max-h-[calc(100vh-20rem)] min-h-0">
          <div className="w-full flex justify-start items-center gap-2 text-lg font-semibold">
            <input
              type="checkbox"
              className="checkbox checkbox-lg border-neutral-200 checked:border-transparent"
              style={{ "--chkbg": hex, "--chkfg": "#2D2D2D" }}
              onChange={handleCheckAll}
              checked={checkAll.age && checkAll.ProvideInform}
            />
            전체동의
          </div>
          <div className="w-full flex flex-col my-2">
        <ul className="w-full flex flex-col pl-2">
          {[
            {
              label: "(필수) 만 14세 이상입니다.",
              content: (
                <>
                  <h4 className="mb-1.5 font-semibold">
                    만14세 이상부터 서비스 이용이 가능합니다.
                  </h4>
                  <p className="text-sm font-medium text-neutral-500">
                    만 14세 미만 고객의 개인정보를 수집하지 않습니다. 만 14세
                    미만의 고객님들께 상담을 제공해 드릴 수 없는 점 양해
                    부탁드립니다.
                  </p>
                </>
              ),
              type: "age",
            },
            {
              label: "(필수) 제 3자 정보 제공에 동의합니다.",
              content: (
                <>
                  <h4 className="mb-1.5 font-semibold">
                    개인정보를 제공 받는 자: 고객 문의와 관련된 협력업체
                  </h4>
                  <ul className="flex flex-col gap-2">
                    <li className="text-sm font-medium">
                      <b className="font-semibold">수집/이용항목: </b>
                      <span className="text-neutral-500">
                        성명, 휴대전화번호, 이메일, 고객 문의 접수 내용 중
                        최소한의 정보
                      </span>
                    </li>
                    <li className="text-medium font-medium">
                      <b className="font-semibold text-base">수집/이용목적: </b>
                      <span className="font-semibold text-base">
                        고객 문의 해결, 불만 처리 등을 위한 고객 문의 처리 목적
                      </span>
                    </li>
                  </ul>
                  <p className="mt-1.5 font-medium text-sm text-neutral-500">
                    정보 주체는 제3자 개인정보 제공에 동의하지 않을 권리가 있습니다. 동의를 거부할 경우, 해당 서비스 이용이 제한될 수 있습니다. 
                  </p>
                  <p className="mt-2.5 font-medium underline">
                    보유기간: 서비스 제공 완료 후 3년 이내
                  </p>
                </>
              ),
              type: "ProvideInform",
            },
          ].map((item, index) => (
            <li className="flex items-start gap-1" key={index}>
              <div className="py-1">
                <input
                  type="checkbox"
                  className="border-transparent checkbox checkbox-md"
                  style={{ "--chkbg": hex, "--chkfg": "#2D2D2D" }}
                  checked={checkAll[item.type]}
                  onChange={() => handleCheckChange(item.type)}
                />
              </div>
              <div
                className={`argree-collapse collapse collapse-arrow ${
                  openIndex === index ? "collapse-open" : ""
                }`}
                onClick={() => handleAccordionClick(index)}
              >
                <div className="p-1 font-medium collapse-title text-neutral-600">
                  <p>{item.label}</p>
                </div>
                <div className="collapse-content">
                  <div className="p-3.5 my-2 border border-zinc-100 rounded-[10px]">
                    {item.content}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
        <p className="flex gap-2 my-3 p-3.5 text-stone-700 text-sm bg-slate-50 rounded-[20px] border border-violet-50 break-keep font-medium">
          <table className="w-full border ">
            <colgroup>
              <col className="w-1/3" />
              <col className="w-auto" />
            </colgroup>
            <tbody>
              <TableRow
                category="수집/이용 항목"
                items={[
                  "휴대전화번호, 채팅상담 내용, (신세계포인트를 통한) 주소, 거래정보",
                ]}
              />
              <TableRow
                category="수집/이용 목적"
                items={[
                  "본인확인절차, 채팅상담 서비스 제공, 민원처리",
                ]}
              />
              <TableRow
                category="보유 및 이용기간"
                styles="p-3 font-medium underline text-base align-top border border-neutral-200"
                items={[
                  "서비스 제공 완료 후 3년 이내",
                ]}
              />
            </tbody>
          </table>
        </p>
        <span className="flex flex-col">
          <span className="inline w-full flex-row text-sm my-1 px-3.5">
            ※ 개인정보를 기재하지 않으실 수 있습니다. 단, 기재하지 않으시는 경우에는 상기 목적의 서비스 이용이 불가합니다.
          </span>
        </span>
        </div>
        </div>
        <div className="flex-shrink-0 mt-4">
          <Button onClick={!isLoading ? handleSubmit : null} disabled={isLoading}>
            {isLoading ? (
              <span className="loading loading-dots loading-lg"></span>
            ) : (
              "확인"
            )}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default PrivacyAgree;
